import { slicedToArray as _slicedToArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import SliderMultiple from './SliderMultiple.js';
import SliderSingle from './SliderSingle.js';
import { VARIANTS as VARIANTS$1, OPEN_ENDS, MAX, MIN, NO_OP, STEP } from '../constants.js';
import Labels from './Labels.js';
import { SliderOrientation } from './Slider.styles.js';
import useSliderOpenEnds from './useSliderOpenEnds.js';

var VARIANTS = Object.values(VARIANTS$1);
var Slider = function Slider(_ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? undefined : _ref$id,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$isPushable = _ref.isPushable,
    isPushable = _ref$isPushable === void 0 ? false : _ref$isPushable,
    _ref$isReversed = _ref.isReversed,
    isReversed = _ref$isReversed === void 0 ? false : _ref$isReversed,
    _ref$labels = _ref.labels,
    labels = _ref$labels === void 0 ? undefined : _ref$labels,
    _ref$max = _ref.max,
    originalMax = _ref$max === void 0 ? MAX : _ref$max,
    _ref$min = _ref.min,
    originalMin = _ref$min === void 0 ? MIN : _ref$min,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? NO_OP : _ref$onChange,
    _ref$onChangeComplete = _ref.onChangeComplete,
    onChangeComplete = _ref$onChangeComplete === void 0 ? NO_OP : _ref$onChangeComplete,
    _ref$openEnds = _ref.openEnds,
    openEnds = _ref$openEnds === void 0 ? undefined : _ref$openEnds,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? STEP : _ref$step,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? undefined : _ref$value,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? VARIANTS$1.LESS_THAN : _ref$variant;
  var _useSliderOpenEnds = useSliderOpenEnds({
      max: originalMax,
      min: originalMin,
      openEnds: openEnds,
      step: step
    }),
    _useSliderOpenEnds2 = _slicedToArray(_useSliderOpenEnds, 2),
    ref = _useSliderOpenEnds2[0],
    _useSliderOpenEnds2$ = _useSliderOpenEnds2[1],
    createChangeHandler = _useSliderOpenEnds2$.createChangeHandler,
    max = _useSliderOpenEnds2$.max,
    min = _useSliderOpenEnds2$.min;
  var isMultiple = Array.isArray(value);
  var Component = isMultiple ? SliderMultiple : SliderSingle;
  var handleChange = createChangeHandler(onChange);
  var handleChangeComplete = createChangeHandler(onChangeComplete);
  return React__default.createElement("div", {
    ref: ref
  }, React__default.createElement(SliderOrientation, {
    $isReversed: isReversed
  }, React__default.createElement(Component, {
    id: id,
    isDisabled: isDisabled,
    isPushable: isMultiple && isPushable,
    max: max,
    min: min,
    onChange: handleChange,
    onChangeComplete: handleChangeComplete,
    openEnds: openEnds,
    step: step,
    testId: testId,
    value: value,
    variant: variant
  })), Array.isArray(labels) && React__default.createElement(Labels, {
    isDisabled: isDisabled,
    isReversed: isReversed,
    labels: labels,
    max: max,
    min: min
  }));
};
Slider.propTypes = {
  id: PropTypes.string,
  isDisabled: PropTypes.bool,
  isPushable: PropTypes.bool,
  isReversed: PropTypes.bool,
  labels: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    position: PropTypes.number.isRequired
  })),
  max: PropTypes.number,
  min: PropTypes.number,
  onChange: PropTypes.func,
  onChangeComplete: PropTypes.func,
  openEnds: PropTypes.oneOf(Object.values(OPEN_ENDS)),
  step: PropTypes.number,
  testId: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
  variant: PropTypes.oneOf(VARIANTS)
};
var SliderInput = Slider;

export { SliderInput as default };
//# sourceMappingURL=Slider.js.map
